import React from 'react';
import { Button, Col, Form, Input, Row, Space, Typography } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import './SupplierContactsFormList.css';

const { Text } = Typography;

interface SupplierContactsFormListProps {
  addLabel: string;
  allowBlankPrimaryName?: boolean;
  contactLabel: string;
  emailLabel: string;
  emailRequiredMessage: string;
  nameLabel: string;
  nameRequiredMessage: string;
  phoneLabel: string;
  phoneRequiredMessage: string;
  removeLabel: string;
}

const SupplierContactsFormList: React.FC<SupplierContactsFormListProps> = ({
  addLabel,
  allowBlankPrimaryName = false,
  contactLabel,
  emailLabel,
  emailRequiredMessage,
  nameLabel,
  nameRequiredMessage,
  phoneLabel,
  phoneRequiredMessage,
  removeLabel
}) => (
  <Form.List name="contactPeople">
    {(fields, { add, remove }) => (
      <div className="supplier-contacts-form-list">
        {fields.map((field, index) => (
          <div key={field.key} className="supplier-contacts-form-list__item">
            <div className="supplier-contacts-form-list__item-header">
              <Text className="supplier-contacts-form-list__item-title">
                {contactLabel} {index + 1}
              </Text>

              {fields.length > 1 && (
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => remove(field.name)}
                  aria-label={removeLabel}
                />
              )}
            </div>

            <Row gutter={12}>
              <Col xs={24} md={8}>
                <Form.Item
                  name={[field.name, 'name']}
                  label={nameLabel}
                  rules={[
                    {
                      validator: async (_rule, value) => {
                        if (String(value || '').trim()) {
                          return;
                        }

                        if (allowBlankPrimaryName && index === 0) {
                          return;
                        }

                        throw new Error(nameRequiredMessage);
                      }
                    }
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  name={[field.name, 'phone']}
                  label={phoneLabel}
                  rules={[{ required: true, message: phoneRequiredMessage }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  name={[field.name, 'email']}
                  label={emailLabel}
                  rules={[
                    { required: true, message: emailRequiredMessage },
                    { type: 'email', message: emailRequiredMessage }
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </div>
        ))}

        <Space>
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => add({ name: '', phone: '', email: '' })}
          >
            {addLabel}
          </Button>
        </Space>
      </div>
    )}
  </Form.List>
);

export default SupplierContactsFormList;
